// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"532":"e48688ad","633":"78159172","672":"05ced90d","762":"f6e52c30","796":"cca36952","874":"ec7762af","916":"1ad2fa59"}[chunkId] + ".css";
};